module.exports = __webpack_public_path__ + "static/img/ic_next.1a9a4f5d.png";